const SIGN_IN_ACTION_PATHS = ['/bolt/login', '/bolt/confirm'];

export function isSignInAction(formAction?: string) {
  return SIGN_IN_ACTION_PATHS.some((path) => formAction?.startsWith(path));
}
